export default __webpack_public_path__ + "static/media/ideas_b.dfbafc3a.PNG";